import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from 'src/app/model/project/project';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';

@Component({
  selector: 'ip-board-extras',
  templateUrl: './ip-board-extras.component.html',
  styleUrls: ['./ip-board-extras.component.scss']
})
export class IPBoardExtrasComponent extends SubscriptionBasedComponent
  implements OnInit, OnDestroy {
  @Input()
  project: Project;
  @Input()
  projectPlacement: ProjectPlacement;
  @Input()
  client: boolean = false;
  @Output()
  update = new EventEmitter<any>();

  multipleIPBoards: boolean = false;

  withOtherOrder: boolean = false;

  emitProjectPlacementVariableChanged = new Subject<any>();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateMultipleIPBoards();
    this.withOtherOrder = !StringHelper.isEmpty(
      this.projectPlacement.otherOrderPlacementInfo
    );

    this.addSubscription(
      this.projectDisplayObservableService.getProductAddedSubscribable(),
      () => {
        this.calculateMultipleIPBoards();
      }
    );
    this.addSubscription(
      this.emitProjectPlacementVariableChanged,
      () =>
        this.projectDisplayObservableService
          .getProjectPlacementVariableChangedSubscribable()
          .next(),
      GeneralHelper.noop,
      500
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.emitProjectPlacementVariableChanged != null) {
      this.emitProjectPlacementVariableChanged.complete();
      this.emitProjectPlacementVariableChanged = null;
    }
  }

  private calculateMultipleIPBoards(): void {
    this.multipleIPBoards =
      CollectionHelper.count(this.project.products, p =>
        ProductHelper.isIPBoard(p)
      ) > 1;
  }

  withOtherOrderChanged(): void {
    if (!this.withOtherOrder) {
      this.projectPlacement.otherOrderPlacementInfo = null;
    }
    this.update.emit();
    this.projectDisplayObservableService
      .getProjectPlacementVariableChangedSubscribable()
      .next();
  }

  otherOrderPlacementInfoChanged(value: string): void {
    this.projectPlacement.otherOrderPlacementInfo = value;
    this.update.emit();
    this.emitProjectPlacementVariableChanged.next();
  }
}
